import { render, staticRenderFns } from "./main.vue?vue&type=template&id=13f1a52a&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=13f1a52a&prod&lang=less&scoped=true"
import style1 from "./main.vue?vue&type=style&index=1&id=13f1a52a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f1a52a",
  null
  
)

export default component.exports